var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var AbstractIpcPadGeneratorInteractionModel = require("../abstractIpcPadGeneratorInteractionModel.js");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var CustomSmdPadGeneratorInteractionModel = require("./customSmdPadGeneratorInteractionModel.js")

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var IpcSmdPadGeneratorInteractionModel = function(data, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    AbstractIpcPadGeneratorInteractionModel.call(this, data, userSettingsModel, showFootprintParams);

    this.addCustomSmdPadGeneratorInteractionModel();
    this.withCustomFootprintParams = this.value("withCustomFootprintParams", true);
    this.withCustomFootprintParams(withCustomFootprintParams);
};

lib_core.inherit(IpcSmdPadGeneratorInteractionModel, AbstractIpcPadGeneratorInteractionModel);
IpcSmdPadGeneratorInteractionModel.$class = 'IpcSmdPadGeneratorInteractionModel';

lib_core.mixin(IpcSmdPadGeneratorInteractionModel, CustomSmdPadGeneratorInteractionModel);
module.exports = IpcSmdPadGeneratorInteractionModel;

IpcSmdPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    AbstractIpcPadGeneratorInteractionModel.prototype.initialize.call(this);

    /*
        component density level list
     */
    for (var d in cio_datamodel.IpcDataModel.ComponentAttribute.densityLevel) {
        this.componentDensityList.push([this.LCLZ(d, d), cio_datamodel.IpcDataModel.ComponentAttribute.densityLevel[d]]);
    }

    /*
       Pad Shapes
     */
    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.padShapes) {
        var s = cio_datamodel.IpcDataModel.ComponentAttribute.padShapes[t];
        this.padShapeList.push([this.LCLZ(t, s), s]);
    }

    //update pad shape list for the following types
    if(self.data instanceof cio_datamodel.IpcDataModel.AluminumElectrolyticData ||
        self.data instanceof cio_datamodel.IpcDataModel.ChipData ||
        self.data instanceof cio_datamodel.IpcDataModel.ChipLedData ||
        self.data instanceof cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData ||
        self.data instanceof cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData ||
        self.data instanceof cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData ||
        self.data instanceof cio_datamodel.IpcDataModel.CrystalData ||
        self.data instanceof cio_datamodel.IpcDataModel.MelfData ||
        self.data instanceof cio_datamodel.IpcDataModel.MoldedBodyData ||
        self.data instanceof cio_datamodel.IpcDataModel.OscillatorCornerConcaveData ||
        self.data instanceof cio_datamodel.IpcDataModel.OscillatorLBendData ||
        self.data instanceof cio_datamodel.IpcDataModel.SodData ||
        self.data instanceof cio_datamodel.IpcDataModel.ToDpakData) {
            for (var i = 0; i < this.padShapeList.length; i++) {
                if (this.padShapeList[i][1] === cio_datamodel.IpcDataModel.ComponentAttribute.padShapes["Oblong"]) {
                    this.padShapeList.splice(i, 1); //remove oblong pad shape
                    break;
                } 
            }
    }

    if(self.data instanceof cio_datamodel.IpcDataModel.Dfn2Data ||
        self.data instanceof cio_datamodel.IpcDataModel.Dfn3Data ||
        self.data instanceof cio_datamodel.IpcDataModel.Dfn4Data) {
            var rectanglePadShape = cio_datamodel.IpcDataModel.ComponentAttribute.padShapes["Rectangle"];
            this.padShapeList = [[this.LCLZ(rectanglePadShape, rectanglePadShape), rectanglePadShape]]; //only rectangle pad shape
    }

    if(self.data instanceof cio_datamodel.IpcDataModel.QfnData || self.data instanceof cio_datamodel.IpcDataModel.SonData) {
        for (var i = 0; i < this.padShapeList.length; i++) {
            if (this.padShapeList[i][1] === cio_datamodel.IpcDataModel.ComponentAttribute.padShapes["RoundedRectangle"]) {
                this.padShapeList.splice(i, 1); //remove rounded rectangle pad shape
                break;
            } 
        }
    }

    this.horizontalLeadToLeadSpanMin = this.shadow("horizontalLeadToLeadSpanMin",
        function() {
            return self.data.horizontalLeadToLeadSpanMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.horizontalLeadToLeadSpanMin(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.horizontalLeadToLeadSpanMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.horizontalLeadToLeadSpanMax = this.shadow("horizontalLeadToLeadSpanMax",
        function() {
            return self.data.horizontalLeadToLeadSpanMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.horizontalLeadToLeadSpanMax(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.horizontalLeadToLeadSpanMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.padWidthMin = this.shadow("padWidthMin",
        function() {
            return self.data.padWidthMin() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            //update lead span for DFN packages
            if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn2Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + self.padWidthMax());
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + value);
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn3Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + (self.padWidthMax() + self.oddPadWidthMax()) / 2);
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + (value + self.oddPadWidthMin()) / 2);
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn4Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + self.padWidthMax());
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + value);
            }

            return self.data.padWidthMin(value * self.getUnitFactor());
        },
        [
            self.data.padWidthMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.padWidthMax = this.shadow("padWidthMax",
        function() {
            return self.data.padWidthMax() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            //update lead span for DFN packages
            if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn2Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + value);
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + self.padWidthMin());
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn3Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + (value + self.oddPadWidthMax()) / 2);
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + (self.padWidthMin() + self.oddPadWidthMin()) / 2);
            } else if (self.data.constructor === cio_datamodel.IpcDataModel.Dfn4Data) {
                self.horizontalLeadToLeadSpanMax(self.horizontalPinPitch() + value);
                self.horizontalLeadToLeadSpanMin(self.horizontalPinPitch() + self.padWidthMin());
            }

            return self.data.padWidthMax(value * self.getUnitFactor());
        },
        [
            self.data.padWidthMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.padHeightMin = this.shadow("padHeightMin",
        function() {
            return self.data.padHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.padHeightMin(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.padHeightMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.padHeightMax = this.shadow("padHeightMax",
        function() {
            return self.data.padHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.padHeightMax(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.padHeightMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyOffsetMin = this.shadow("bodyOffsetMin",
        function() {
            return self.data.bodyOffsetMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.bodyOffsetMin(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.bodyOffsetMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.bodyOffsetMax = this.shadow("bodyOffsetMax",
        function() {
            return self.data.bodyOffsetMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.bodyOffsetMax(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.bodyOffsetMax, self.userSettingsModel.distanceUnit
        ]
    );

    this.fabricationTolerance = this.shadow("fabricationTolerance",
        function() {
            return self.data.fabricationTolerance() / self.getUnitFactor();
        },
        function(value) {
            return self.data.fabricationTolerance(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.fabricationTolerance, this.userSettingsModel.distanceUnit
        ]
    );

    this.placementTolerance = this.shadow("placementTolerance",
        function() {
            return self.data.placementTolerance() / self.getUnitFactor();
        },
        function(value) {
            return self.data.placementTolerance(parseFloat(value) * self.getUnitFactor());
        },
        [
            self.data.placementTolerance, this.userSettingsModel.distanceUnit
        ]
    );

    this.showIpcFootprintParams = this.shadow("showIpcFootprintParams",
        function() {
            return !this.data.hasCustomFootprint()
        },
        null,
        [
            self.data.hasCustomFootprint
        ]
    ); 
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorName = function() {
    var name = '';

    switch(this.data.constructor) {
        case cio_datamodel.IpcDataModel.SoicSopData:
            name = this.LCLZ("SOIC_SOP", "SOIC, SOP");
        break;

        case cio_datamodel.IpcDataModel.CfpData:
            name = this.LCLZ("CFP", "CFP");
        break;

        case cio_datamodel.IpcDataModel.QfpData:
            name = this.LCLZ("QFP", "QFP");
        break;

        case cio_datamodel.IpcDataModel.CqfpData:
            name = this.LCLZ("CQFP", "CQFP");
        break;

        case cio_datamodel.IpcDataModel.QfnData:
            name = this.LCLZ("QFN", "QFN");
        break;

        case cio_datamodel.IpcDataModel.Sot23Data:
            name = this.LCLZ("SOT23", "SOT23");
        break;

        case cio_datamodel.IpcDataModel.SotflData:
            name = this.LCLZ("SOTFL", "SOTFL");
        break;

        case cio_datamodel.IpcDataModel.Sot223Data:
            name = this.LCLZ("SOT223", "SOT223");
        break;

        case cio_datamodel.IpcDataModel.ToDpakData:
            name = this.LCLZ("TO_DPAK", "TO, DPAK");
        break;

        case cio_datamodel.IpcDataModel.Sot143Data:
            name = this.LCLZ("SOT143", "SOT143");
        break;

        case cio_datamodel.IpcDataModel.ChipData:
            name = this.LCLZ("CHIP", "Chip");
        break;

        case cio_datamodel.IpcDataModel.ChipLedData:
            name = this.LCLZ("CHIP_LED", "Chip LED");
        break;

        case cio_datamodel.IpcDataModel.SodData:
            name = this.LCLZ("SOD", "SOD");
        break;

        case cio_datamodel.IpcDataModel.MoldedBodyData:
            name = this.LCLZ("MOLDED_BODY", "Molded Body");
        break;

        case cio_datamodel.IpcDataModel.SodflData:
            name = this.LCLZ("SODFL", "SODFL");
        break;

        case cio_datamodel.IpcDataModel.Dfn2Data:
            name = this.LCLZ("DFN_2", "DFN-2");
        break;

        case cio_datamodel.IpcDataModel.Dfn3Data:
            name = this.LCLZ("DFN_3", "DFN-3");
        break;

        case cio_datamodel.IpcDataModel.Dfn4Data:
            name = this.LCLZ("DFN_4", "DFN-4");
        break;

        case cio_datamodel.IpcDataModel.AluminumElectrolyticData:
            name = this.LCLZ("ECAP", "E-Cap");
        break;

        case cio_datamodel.IpcDataModel.CrystalData:
            name = this.LCLZ("CRYSTAL", "Crystal");
        break;

        case cio_datamodel.IpcDataModel.BgaData:
            name = this.LCLZ("BGA", "BGA");
        break;

        case cio_datamodel.IpcDataModel.MelfData:
            name = this.LCLZ("MELF", "MELF");
        break;

        case cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData:
            name = this.LCLZ("CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE", "Chip Array, 2 Side Flat/Concave");
        break;

        case cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData:
            name = this.LCLZ("CHIP_ARRAY_TWO_SIDE_CONVEX", "Chip Array, 2 Side Convex");
        break;

        case cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData:
            name = this.LCLZ("CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE", "Chip Array, 4 Side Flat/Concave");
        break;

        case cio_datamodel.IpcDataModel.PlccData:
            name = this.LCLZ("PLCC", "PLCC");
        break;

        case cio_datamodel.IpcDataModel.OscillatorCornerConcaveData:
            name = this.LCLZ("OSCILLATOR_CORNER_CONCAVE", "Oscillator Corner Concave");
        break;

        case cio_datamodel.IpcDataModel.OscillatorJLeadData:
            name = this.LCLZ("OSCILLATOR_J_LEAD", "Oscillator J-Lead");
        break;

        case cio_datamodel.IpcDataModel.OscillatorLBendData:
            name = this.LCLZ("OSCILLATOR_L_BEND", "Oscillator L-Bend");
        break;

        case cio_datamodel.IpcDataModel.SojData:
            name = this.LCLZ("SOJ", "SOJ");
        break;

        case cio_datamodel.IpcDataModel.SonData:
            name = this.LCLZ("SON_DFN", "SON (DFN)");
        break;
    }

    return name;
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('leadSpan', 'Lead Span'), false, this.horizontalLeadToLeadSpanMin, false, this.horizontalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForBodyOffset = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('A1', this.LCLZ('bodyOffset', 'Body Offset'), false, this.bodyOffsetMin, true, null, this.userSettingsModel.distanceUnit)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElementForTolerance = function() {
    var fabTol = PackageGeneratorInspectorConfig.getValueFixedUnit(this.LCLZ('fabricationTolerance', 'Fabrication Tolerance'), '', this.fabricationTolerance, this.userSettingsModel.distanceUnit, this.showFootprintParams() ? this.showIpcFootprintParams : this.showFootprintParams);
    var placeTol = PackageGeneratorInspectorConfig.getValueFixedUnit(this.LCLZ('placementTolerance', 'Placement Tolerance'), '', this.placementTolerance, this.userSettingsModel.distanceUnit, this.showFootprintParams() ? this.showIpcFootprintParams : this.showFootprintParams);

    return [fabTol, placeTol];
};

AbstractIpcPadGeneratorInteractionModel.prototype.getInspectorElementForDensityLevel = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('densityLevel', 'Density Level'), this.densityLevel, this.componentDensityList, this.showFootprintParams() ? this.showIpcFootprintParams : this.showFootprintParams)];
};

IpcSmdPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
